/**
 * Where this questionnaire deployment's chat calls, and its contact link.
 *
 * Whether chat shows at all is the `fe_chat_enabled` Flagsmith flag, read in
 * `QuestionnaireChat`; there is no build-time switch. The API path is
 * same-origin on purpose: the browser calls this site, and the site's server
 * forwards to chat-service, so no session cookie leaves this origin and
 * chat-service is not a second browser endpoint.
 */

export interface ChatConfig {
  apiBasePath: string;
  contact: { label: string; url: string };
}

const DEFAULT_API_BASE_PATH = '/api/chat';
// Chat visitors are prospects, so the link goes to the sales inbox (inquiry@); advocate@ is the
// operational inbox for customers.
const DEFAULT_CONTACT = {
  label: 'email an advocate',
  url: 'mailto:inquiry@resolvemedicalbills.com',
};

export function readChatConfig(env: ImportMetaEnv = import.meta.env): ChatConfig {
  return {
    apiBasePath: env.VITE_CHAT_API_BASE_PATH || DEFAULT_API_BASE_PATH,
    contact: {
      label: env.VITE_CHAT_CONTACT_LABEL || DEFAULT_CONTACT.label,
      url: env.VITE_CHAT_CONTACT_URL || DEFAULT_CONTACT.url,
    },
  };
}
